export const activities = [
  {
    id: 1,
    heading: 'Chronologické řazení',
    path: '/razeni',
    className: 'activity__hourglass',
  },
  {
    id: 2,
    heading: 'Přesouvání po mapě',
    path: '/presouvani',
    className: 'activity__map',
  },
  {
    id: 3,
    heading: 'Dobývání území',
    path: '/dobyvani',
    className: 'activity__aztec',
  },
  {
    id: 4,
    heading: 'Střílení',
    path: '/strileni',
    className: 'activity__arrow',
  },
];

export const places = [
  {
    id: 1,
    text: 'mys Dobré naděje',
    answer: 'AF',
    info: 'Mys Dobré naděje jako první Evropan obeplul v roce 1488 Bartolomeo Dias.',
  },
  {
    id: 2,
    text: 'Španělsko',
    answer: 'EU',
    info: 'Díky získaným územím v Americe španělský král Karel V. prohlašoval: „Nad mojí říší Slunce nezapadá!“',
  },
  {
    id: 3,
    text: 'Ceuta',
    answer: 'AF',
    info: 'Maurské město Ceuta bylo první portugalskou kolonií mimo evropské území. Portugalci tak došli k poznání, jak je Afrika bohatá např. na slonovinu a zlato.',
  },
  {
    id: 4,
    text: 'Newfoundland',
    answer: 'NA',
    info: 'Norský Viking Leif Eriksson byl patrně prvním evropským objevitelem Ameriky. Kolem roku 1000 se vylodil na ostrově Newfoundland.',
  },
  {
    id: 5,
    text: 'Indie',
    answer: 'AS',
    info: 'Před objevnými plavbami probíhaly cesty do Indie a Číny pouze po souši. Kupecké karavany byly často přepadávány.',
  },
  {
    id: 6,
    text: 'San Salvador',
    answer: 'NA',
    info: 'Prvním místem, které Kryštof Kolumbus v Americe objevil, byl právě jeden z ostrovů Bahamského souostroví – San Salvador.',
  },
  {
    id: 7,
    text: 'Ohňová země',
    answer: 'SA',
    info: 'Souostroví Ohňová země objevil v roce 1520 Fernão de Magalhães. Magalhãesův průliv spojuje Atlantský a Tichý oceán.',
  },
  {
    id: 8,
    text: 'Austrálie',
    answer: 'AU',
    info: 'Původní obyvatelé Austrálie jsou nazýváni Austrálci, též Aboridžinci. Jejich známým nástrojem je bumerang. ',
  },
];

export const events = [
  [
    {
      event: 'Objevení Ameriky K. Kolumbusem',
      order: 2,
      year: '1492',
    },
    {
      event: 'Obeplutí mysu Dobré naděje B. Diasem',
      order: 1,
      year: '1488',
    },
    {
      event: 'Doplutí Vikingů do Sev. Ameriky',
      order: 0,
      year: 'kolem r. 1000',
    },
    {
      event: 'Tordesillaská smlouva',
      order: 3,
      year: '1494',
    },
  ],
  [
    {
      event: 'Plavby J. Cooka do Tichomoří',
      order: 3,
      year: '2. pol. 18. stol.',
    },
    {
      event: 'Doplutí Vasco de Gama do Indie.',
      order: 1,
      year: '1498',
    },
    {
      event: 'Začátek dobývání říše Aztéků.',
      order: 2,
      year: '1519',
    },
    {
      event: 'Doplutí Vikingů do Grónska',
      order: 0,
      year: 'kolem r. 875',
    },
  ],
  [
    {
      event: 'Začátek dobývání Incké říše.',
      order: 2,
      year: '1532',
    },
    {
      event: 'Obeplutí mysu Bojador',
      order: 0,
      year: '1433',
    },
    {
      event: 'Začátek novověku',
      order: 1,
      year: '1492',
    },
    {
      event: 'Poražení španělské Neporazitelné armády',
      order: 3,
      year: '1588',
    },
  ],
  [
    {
      event: 'Začátek reformace.',
      order: 1,
      year: '1517',
    },
    {
      event: 'Dobytí Konstantinopole Turky.',
      order: 0,
      year: '1453',
    },
    {
      event: 'Vznik USA. 4. července',
      order: 3,
      year: '1776',
    },
    {
      event: 'Založení první Britské kolonie – Virginie.',
      order: 2,
      year: '1606',
    },
  ],
];

export const statement = [
  {
    id: 1,
    text: 'Kontinent Amerika byl pojmenován po cestovateli Amerigo Vespucci, který popsal východní pobřeží.',
    answer: true,
  },
  {
    id: 2,
    text: 'Francisco Pizarro dobyl říši Aztéků.',
    answer: false,
  },
  {
    id: 3,
    text: 'Záměrem Portugalců bylo dostat se do Indie jižní cestou kolem Afriky.',
    answer: true,
  },
  {
    id: 4,
    text: 'Kryštof Kolumbus se rozhodl plout do Indie východním směrem.',
    answer: false,
  },
  {
    id: 5,
    text: 'Výprava Magalhãese přinesla důkaz o kulatosti světa.',
    answer: true,
  },
  {
    id: 6,
    text: 'Do Evropy byly z Ameriky dováženy nové plodiny (např. rýže a čaj).',
    answer: false,
  },
  {
    id: 7,
    text: 'Conquistador je synonymem slova dobyvatel.',
    answer: true,
  },
  {
    id: 8,
    text: 'S africkými domorodci dováženými do Ameriky bylo zacházeno velmi ohleduplně.',
    answer: false,
  },
  {
    id: 9,
    text: 'Nový svět je v souvislosti se zámořskými objevy označením po Afriku.',
    answer: false,
  },
  {
    id: 10,
    text: 'Z Ameriky byly poprvé do Evropy přivezeny některá zvířata, např. krocan a morče.',
    answer: true,
  },
  {
    id: 11,
    text: 'Nezbytným předpokladem úspěšných plaveb byly lodě s kormidlem a plachtami.',
    answer: true,
  },
  {
    id: 12,
    text: 'Kompas byl vynalezen Portugalci v důsledku zámořkých objevů .',
    answer: false,
  },
  {
    id: 13,
    text: 'Koncem 16. století se k dosavadním námořním velmocem, Španělsku a Portugalsku, přidala Anglie a Nizozemí.',
    answer: true,
  },
  {
    id: 14,
    text: 'Do Ameriky byly přeneseny spalničky, chřipka a neštovice. Imunitní systém domorodců na ně byl přizpůsoben.',
    answer: false,
  },
  {
    id: 15,
    text: 'Kolumbus byl přesvědčen, že v roce 1492 doplul do Indie.',
    answer: true,
  },
  {
    id: 16,
    text: 'Španělé získali v Americe obrovské bohatství. ',
    answer: true,
  },
  {
    id: 17,
    text: 'Ve středověku si vzdělaní lidé stále mysleli, že země je placatá. ',
    answer: false,
  },
  {
    id: 18,
    text: 'Kryštof Kolumbus měl tři lodě: Niňu, Pintu a Pinďu.',
    answer: false,
  },
  {
    id: 19,
    text: 'První ostrov, který Evropané v Karibiku objevili, pojmenovali San Salvador.',
    answer: true,
  },
  {
    id: 20,
    text: 'Indiáni před příchodem Evropanů lovili bizony na koních.',
    answer: false,
  },
  {
    id: 21,
    text: 'Aztékové konali podle odhadů kolem 6 000 lidských obětí ročně.',
    answer: true,
  },
  {
    id: 22,
    text: 'Cesta do Ameriky trvala Kolumbovi přibližně 3 měsíce.',
    answer: true,
  },
  {
    id: 23,
    text: 'Inkové a Aztékové používali primitivní železné nástroje.',
    answer: false,
  },
  {
    id: 24,
    text: 'Původní obyvatelé Ameriky neznali kolo.',
    answer: true,
  },
  {
    id: 25,
    text: 'Evropští dobyvatelé měli velkou početní převahu.',
    answer: false,
  },
];

export const targets = [
  [
    {
      word: 'morče',
      answer: true,
      id: 1,
      animationDelay: '6s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'brambory',
      answer: true,
      id: 2,
      animationDelay: '3s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'rýže',
      answer: false,
      id: 3,
      animationDelay: '0s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'krocan',
      answer: true,
      id: 4,
      animationDelay: '7s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'čaj',
      answer: false,
      id: 5,
      animationDelay: '2s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'kukuřice',
      answer: true,
      id: 6,
      animationDelay: '4s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'kůň',
      answer: false,
      id: 7,
      animationDelay: '0.5s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
    {
      word: 'jahody',
      answer: false,
      id: 8,
      animationDelay: '5s',
      category: 'Plodiny a zvířata dovezené z Ameriky',
    },
  ],
  [
    {
      word: 'kormidlo',
      answer: true,
      id: 1,
      animationDelay: '5s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'GPS',
      answer: false,
      id: 2,
      animationDelay: '0s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'kolonizace',
      answer: false,
      id: 3,
      animationDelay: '3s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'porážka Inků',
      answer: false,
      id: 4,
      animationDelay: '6s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'kompas',
      answer: true,
      id: 5,
      animationDelay: '0.5s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'karaka',
      answer: true,
      id: 6,
      animationDelay: '7s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'astroláb',
      answer: true,
      id: 7,
      animationDelay: '4s',
      category: 'Předpoklady zámořských plaveb',
    },
    {
      word: 'nové nemoci',
      answer: false,
      id: 8,
      animationDelay: '3s',
      category: 'Předpoklady zámořských plaveb',
    },
  ],
  [
    {
      word: 'prase',
      answer: true,
      id: 1,
      animationDelay: '0s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'kůň',
      answer: true,
      id: 2,
      animationDelay: '5s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'kakao',
      answer: false,
      id: 3,
      animationDelay: '6s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'dýně',
      answer: false,
      id: 4,
      animationDelay: '3s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'včely',
      answer: true,
      id: 5,
      animationDelay: '7s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'banány',
      answer: true,
      id: 6,
      animationDelay: '0.5s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'paprika',
      answer: false,
      id: 7,
      animationDelay: '3s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
    {
      word: 'karibu',
      answer: false,
      id: 8,
      animationDelay: '4s',
      category: 'Plodiny a zvířata dovezené do Ameriky',
    },
  ],
];

export const lighthousesArray = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];
